var map = {
	"./AlertIcon.svg": "a8f0",
	"./Company-logo.svg": "10a4",
	"./Cost-logo.svg": "a118",
	"./Creditors-logo.svg": "636f",
	"./Dashboard-logo.svg": "c04c",
	"./FINTI-logo.svg": "0b7d",
	"./Financial-logo.svg": "2d84",
	"./FintiLogo.svg": "b017",
	"./IlliquidsLogo.svg": "eff6",
	"./Logo-login.svg": "8f97",
	"./Remittances-logo.svg": "2f86",
	"./Requests-logo.svg": "18af",
	"./System-logo.svg": "f582",
	"./Users-logo.svg": "f64a",
	"./Vendor_Logo.svg": "8722",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f65";